import React from "react"
import { Container } from "react-bootstrap"
import '../styles/login.css';
import AppLogo from './AppLogo';

const clientId = '724e3751d2f346eab35f922c9b2826b4';
const redirectUri = 'https://streambeat.sbs';
const scope = 'streaming user-read-email user-read-private user-library-read user-library-modify user-read-playback-state user-modify-playback-state user-read-recently-played';

const AUTH_URL = `https://accounts.spotify.com/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&scope=${encodeURIComponent(scope)}`;

export default function Login() {
  return (
    <Container
      className="login-container d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh" }}
    >
      <AppLogo />
      <a className="login-btn" href={AUTH_URL}>
        Login With Spotify
      </a>
    </Container>
  )
}

